import { api } from "./client";

export type Post = {
  post_id: number;
  title: string;
  content: string;
  topic_id: number;
  topic_name: string;
  user_id: number;    
  username: string;
  vote_score: number;
  comment_count: number;
  created_at: string;
  top_comments?: {
      username: string;
      content: string;
  }[];
};

export async function getPosts(topicId?: number, sortBy?: string, search?: string) {
  const params = new URLSearchParams();
  if (topicId) params.append("topic", String(topicId));
  if (sortBy) params.append("sortBy", sortBy);
  if (search) params.append("search", search);

  const res = await api<Post[] | null>(`/posts?${params.toString()}`, "GET");
  return res ?? [];
}


export async function getPost(id: number) {
  return api<Post>(`/posts/${id}`, "GET");
}

export async function createPost(title: string, content: string, topic_name: string) {
  return api<Post>(`/posts`, "POST", { title, content, topic_name }, true);
}

export async function deletePost(id: number) {
  return api(`/posts/${id}`, "DELETE", undefined, true);
}
